import { Dialog } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import { t } from 'i18next';

import IPosition from 'types/Position';
import { useFeatureFlags } from 'utils/features';
import { executeFunctionsCurried } from 'utils/functionUtils';
import { getRequestTimeOffTitleValue } from 'utils/positionUtils';
import { RequestTimeOffSettingsForm } from '../forms/RequestTimeOffSettingsForm';

export interface IRequestTimeOffSettingsDetailProps {
  className?: ClassName;
  editable: boolean;
  position: IPosition;
  onUpdate: () => Promise<any>;
}

const RequestTimeOffSettingsDetail = (props: IRequestTimeOffSettingsDetailProps) => {
  const { className, position, onUpdate, editable } = props;

  const isRequestTimeOffEnabled = useFeatureFlags('TIME_OFF_REQUEST');
  const formOpenable = useOpenable();

  function getPositionValue() {
    const canRequestTimeOff = position.canRequestTimeOff;
    return getRequestTimeOffTitleValue(!!canRequestTimeOff);
  }

  const classes = classNames('request-time-off-settings-detail', className);

  return (
    <>
      <ProDetailsItem
        title={t('Request Time Off')}
        onClick={formOpenable.open}
        value={getPositionValue()}
        hint={'Can add, edit, and remove time off requests for self.'}
        className={classes}
        disabled={!editable || !isRequestTimeOffEnabled}
      />
      <Dialog position={'center'} isOpen={formOpenable.isOpen} onClose={formOpenable.close}>
        <RequestTimeOffSettingsForm
          className="mt-4 p-8"
          position={position}
          onSubmit={executeFunctionsCurried(onUpdate, formOpenable.close)}
        />
      </Dialog>
    </>
  );
};

export default RequestTimeOffSettingsDetail;
